export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "success_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["리워드 전송 완료 후 안내 메일이 발송 예정입니다"])}
    }
  })
}
